import { fetchApi } from '@/config/axiosSetting';
import {
  GetSurveyChartQueryParamsType,
  GetSurveyChartQueryResponseType,
} from './getSurveyChartQuery.type';

export const getSurveyChartFunction = (
  params: GetSurveyChartQueryParamsType,
): Promise<GetSurveyChartQueryResponseType> => {
  return fetchApi.get('/survey/survey_trend/', { params });
};
